import React, { useEffect, useState } from "react";
import { Cookies } from "../../../../index.js";
import { alert_error, alert_success } from "../../../../AppContext";
import { update_media_link_url, update_media_link_phone } from '../../../../order/orders/actions.js';
import { useSelector, useDispatch } from 'react-redux';

const AboutUs = ({ datajoptiktok, base64Image_1, handleImageChange_1 }) => {
    const [show_example, setshow_example] = useState(false);
    const dispatch = useDispatch();
    const media_link_url = useSelector(state => state.media_link_url);
    const media_link_phone = useSelector(state => state.media_link_phone);
    const media_link_url_cookie = Cookies.get('media_link_url');
    const media_link_phone_cookie = Cookies.get('media_link_phone');
    const set_media_link_url = (value) => {
        dispatch(update_media_link_url(value));
        Cookies.set('media_link_url', value, { expires: 300 });
    };
    const set_media_link_phone = (value) => {
        dispatch(update_media_link_phone(value));
        Cookies.set('media_link_phone', value, { expires: 300 });
    };
    useEffect(() => {
        if (media_link_url_cookie) {
            set_media_link_url(media_link_url_cookie);
        }
        if (media_link_phone_cookie) {
            set_media_link_phone(media_link_phone_cookie);
        }
    }, []);
    return (
        <>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Mở zalo</h2>
                <div className="text-center">
                    <a href={datajoptiktok.url_jop}
                        target="_blank" >Ấn vô link sau để mở zalo: {datajoptiktok.url_jop} </a>
                </div>
            </div>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Bước 2: Vô nhóm</h2>
                <div className="text-center">
                    <li>Tham gia nhóm và chọn tắt thông báo.</li>
                </div>
            </div>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Xem ảnh mẫu</h2>
                <div className="text-center">
                    <div
                        className="button inline-block px-2 py-1 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition duration-300"
                        onClick={() => setshow_example(!show_example)}
                    >
                        Xem hình ảnh mẫu ở đây
                    </div>
                    {show_example && (
                        <div className="flex text-center">
                            <div className="mx-auto" >
                                Ảnh tham gia: <img src='https://hust.media/link/load_image/zalo_img.PNG' alt="Selected" className=" w-36 rounded mr-4" />
                            </div>
                            {/* <div >
                                        Ảnh 2 link tham gia: <img src='https://hust.media/jop/google/zalo2.png' alt="Selected" className="w-28 rounded" />
                                    </div> */}
                        </div>
                    )}
                </div>
            </div>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Nhập info của bạn nếu có</h2>
                <label className="block">
                    <span className="text-sm font-medium text-gray-700">Tên tài khoản</span>
                    <input
                        type="text"
                        value={media_link_url}
                        onChange={(e) => set_media_link_url(e.target.value)}
                        placeholder="Nhập tên tài khoản..."
                        className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-300"
                    />
                </label>

                {/* Số điện thoại */}
                <label className="block">
                    <span className="text-sm font-medium text-gray-700">Số điện thoại</span>
                    <input
                        type="text"
                        value={media_link_phone}
                        onChange={(e) => set_media_link_phone(e.target.value)}
                        placeholder="Ví dụ: +84912345678"
                        className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-300"
                    />
                </label>
            </div>
            <div>
                <h2 className="text-lg font-bold mb-1">Bước cuối: Gửi ảnh</h2>
                <ul className="list-disc pl-6">
                    <li>

                        {/* <div>
                                    Ảnh 1 tên nhóm:
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        className="rounded"
                                    />
                                    {base64Image && (
                                        <div >
                                            <img src={base64Image} alt="Selected" className="w-44 rounded mr-4" />
                                        </div>
                                    )}
                                </div> */}
                        <div className="text-center">
                            Ảnh link tham gia:
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange_1}
                                className="rounded"
                            />
                            {base64Image_1 && (
                                <div className="">
                                    <img src={base64Image_1} alt="Selected" className="mx-auto w-44 rounded mr-4" />
                                </div>
                            )}
                        </div>

                    </li>

                    <li className="text-sm">Lưu ý: Chỉ làm trên điện thoại, ảnh cần hiển thị rõ đầy đủ tên nhóm và yêu cầu tham gia</li>
                </ul>
            </div>
        </>
    );
}

export default AboutUs;
